<template>
  <v-btn
      color="blue darken-1"
      text
      :disabled="isDisabled"
      @click="Clicked"
  >
    {{buttonText}}
  </v-btn>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  props: {
    isDisabled: Boolean,
    buttonText: String
  },
  methods: {
    Clicked: function (){
      this.$emit("click");
    },
  },
})
</script>
